module.exports = __webpack_public_path__ + "staticcomp/img/share.d7b9a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/3/share.jpg
// module id = SYcB
// module chunks = 39